// Batch 35 · fork w2 — P53-R2: the "credit" tag next to a vouching row's amount (the GL line is a credit). EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B35W2 = {
  en: {
    b35w2: {
      credit: "credit",
      // PR 56 review · R56-1: neutral — the difference compares the absolute amount; a reversal has its own tag
      creditTitle: "The general ledger line is a credit. The difference compares the absolute amount with the document; a reversal is marked separately.",
    },
  },
  ar: {
    b35w2: {
      credit: "دائن",
      creditTitle: "سطر دفتر الأستاذ العام دائن. يقارن الفرق المبلغ المطلق بالمستند، ويُعلَّم القيد العكسي بعلامة مستقلة.",
    },
  },
};

export default I18N_B35W2;
